const getters = {
    conditions: state => state.conditions
}

export default getters